export default "__VITE_ASSET__CpLMpnbv__"